module.exports = __webpack_public_path__ + "9073f163f91f1eef4f1fdbbe1fb59d15.svg";